import React from 'react';
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogCloseButton,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  Text,
} from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';

interface BulkProgressDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BulkProgressDialog = React.memo(function BulkProgressDialog({ isOpen, onClose }: BulkProgressDialogProps) {
  const { t } = useTranslation('moniterByRecruiters');

  const cancelRef = React.useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      size="lg"
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader data-testid="dialog-header">{t('bulk.progressDialog.header')}</AlertDialogHeader>

        <AlertDialogCloseButton />

        <AlertDialogBody>
          <Text>
            {t('bulk.progressDialog.bodyText1')}
            <Text as="span" fontWeight="bold" display="inline">
              {t('bulk.progressDialog.bodyText2')}
            </Text>
            {t('bulk.progressDialog.bodyText3')}
          </Text>
        </AlertDialogBody>

        <AlertDialogFooter>
          <Button ref={cancelRef} onClick={onClose} data-testid="dialog-button">
            {t('bulk.progressDialog.button')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
});
